import { useTranslation } from 'react-i18next';
import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { Popup } from '@/components';
import { links } from '@/components/contacts/Links';
import { isTelSchema, isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { ContactLink } from '@/components/contacts/Links';
import { isRunningInApp } from '@/utilities/sizeUtils';
import { useNotificationStore } from '@/stores/notificationstore';

import './ContactsPopup.css';
import {
  CommonPageContainer,
  CommonPageHeader,
  CommonPageScrollableContent,
} from '../common/CommonPageComponents.style';

export default function ContactsPopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();
  const showNotification = useNotificationStore((state) => state.showNotification);

  async function copyClipboard(url: string) {
    await navigator.clipboard.writeText(url);
    const message = t('general.copiedClipboard');
    showNotification('success', message, undefined, 1);
  }

  function getItem(link: ContactLink) {
    if (!isRunningInApp() && !isPhoneOrHighScreen()) {
      return (
        <ListItem key={link.href} sx={{ pl: '8px' }}>
          {isTelSchema(link.href) ? (
            <ListItemButton onClick={() => copyClipboard(link.text)} data-qa-element-id={link.data_qa_element_id}>
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={link.text} />
            </ListItemButton>
          ) : (
            <ListItemButton component="a" href={link.href} target="_blank" data-qa-element-id={link.data_qa_element_id}>
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={link.text} />
            </ListItemButton>
          )}
        </ListItem>
      );
    }

    return (
      <ListItem key={link.href} sx={{ pl: 0 }}>
        <ListItemButton component="a" href={link.href} target="_blank" data-qa-element-id={link.data_qa_element_id}>
          <ListItemIcon>{link.icon}</ListItemIcon>
          <ListItemText primary={link.text} />
        </ListItemButton>
      </ListItem>
    );
  }

  function ContactsSection({ links }: { links: ContactLink[] }) {
    return (
      <div className="contacts-root">
        <div className="contacts-contacts-container">
          <List className="contacts-list-item">{links.map((link) => getItem(link))}</List>
        </div>
      </div>
    );
  }

  const header = (
    <div className="popup-header-logo">
      <img src="itrack-logo.png" className="header-logo" alt="iTrack logo" data-qa-element-id="popup_header_logo" />
    </div>
  );

  const body = (
    <div className="contacts-root">
      <div className="contacts-contacts-container">
        <List className="contacts-list-item-mobil">
          {links.map((link) => {
            const item = getItem(link);
            return link.divider ? (
              <>
                {item}
                <Divider />
              </>
            ) : (
              item
            );
          })}
        </List>
      </div>
    </div>
  );

  function body2() {
    const firstSectionLinks = links.slice(0, 3);
    const contactLinks = links.slice(3, 5);
    const socialLinks = links.slice(5, 9);

    return (
      <>
        <ContactsSection links={firstSectionLinks} />

        <ContactsSection links={contactLinks} />

        <ContactsSection links={socialLinks} />
      </>
    );
  }

  return isPhoneOrHighScreen() ? (
    <Popup
      size={'sm'}
      header={header}
      body={body}
      footer={undefined}
      closePopup={closePopup}
      popupTitle={t('mainMenu.contactSubmenu.contactInformationTitle')}
      isFullScr={isPhoneOrHighScreen() && true}
      leftText={true}
      hideBackdrop={isPhoneOrHighScreen() ? true : false}
      isNewLookAvailable={true}
      showCloseButton={true}
    />
  ) : (
    <CommonPageContainer data-qa-element-id="contact_details">
      <CommonPageHeader data-qa-element-id="contact_details_view_title">
        {t('mainMenu.contactSubmenu.contactInformationTitle')}
      </CommonPageHeader>

      <CommonPageScrollableContent>
        {header}
        {body2()}
      </CommonPageScrollableContent>
    </CommonPageContainer>
  );
}
